import { Route } from "components/utils";
import { Dashboard as ManufacturingDashboard } from "pages/manufacturingNew/dashboard/Dashboard";
import { NotFound } from "pages/notFound";
import { RouteComponentProps, Switch } from "react-router-dom";

export const Dashboard = ({ match }: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route
        component={ManufacturingDashboard}
        exact={true}
        path={`${match.path}`}
        title="Milo - produkcja"
      />
      <Route component={NotFound} exact={true} path="*" title="Milo" />
    </Switch>
  );
};
